import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";  // Import Authentication

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMjsqD2P82xkqr27ofEHFOLDryJEUOy1g",
  authDomain: "riqc-attendance.firebaseapp.com",
  projectId: "riqc-attendance",
  storageBucket: "riqc-attendance.appspot.com",
  messagingSenderId: "111438598983",
  appId: "1:111438598983:web:15513426f647455fb2b262",
  measurementId: "G-X516SQJ5N8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); // Initialize Authentication

// Export as named exports
export { db, auth };
